"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect, useState } from "react";
import css from "./carousel.module.scss";
interface ICarouselProps {
  children: ReactNode[];
  className?: string;
  interval?: number;
  itemsPerPage?: number;
}
const Carousel = props => {
  const $ = _c(30);
  const {
    children,
    className,
    interval,
    itemsPerPage: t0
  } = props;
  const itemsPerPage = t0 === undefined ? 3 : t0;
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = Math.ceil(children.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const currentItems = children.slice(startIndex, startIndex + itemsPerPage);
  const [isPaused, setIsPaused] = useState(false);
  let t1;
  let t2;
  if ($[0] !== interval || $[1] !== isPaused || $[2] !== totalPages) {
    t1 = () => {
      if (!interval || totalPages <= 1 || isPaused) {
        return;
      }
      const timer = setInterval(() => {
        setCurrentPage(prevPage => (prevPage + 1) % totalPages);
      }, interval);
      return () => clearInterval(timer);
    };
    t2 = [interval, totalPages, isPaused];
    $[0] = interval;
    $[1] = isPaused;
    $[2] = totalPages;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  const t3 = `${css.carousel} ${className}`;
  const t4 = css;
  const t5 = `repeat(${itemsPerPage}, 1fr)`;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      gridTemplateColumns: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t10;
  let t11;
  let t12;
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsPaused(true);
    t8 = () => setIsPaused(false);
    t9 = () => setIsPaused(true);
    t10 = () => setIsPaused(false);
    t11 = () => setIsPaused(true);
    t12 = () => setIsPaused(false);
    $[7] = t10;
    $[8] = t11;
    $[9] = t12;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[7];
    t11 = $[8];
    t12 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  const t13 = currentItems.map(_temp);
  let t14;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t12 || $[16] !== t13 || $[17] !== t4.carouselTrack || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t14 = <div className={t4.carouselTrack} style={t6} onMouseEnter={t7} onMouseLeave={t8} onMouseDown={t9} onMouseUp={t10} onTouchStart={t11} onTouchEnd={t12}>{t13}</div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t4.carouselTrack;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== currentPage || $[24] !== totalPages) {
    t15 = totalPages > 1 && <div className={css.carouselDots}>{Array.from({
        length: totalPages
      }).map((_, index_0) => <button key={index_0} className={`${css.carouselDot} ${index_0 === currentPage ? css.active : ""}`} aria-label={"carousel-tab-" + index_0} onClick={() => setCurrentPage(index_0)} />)}</div>;
    $[23] = currentPage;
    $[24] = totalPages;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t3) {
    t16 = <div className={t3}>{t14}{t15}</div>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t3;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  return t16;
};
export default Carousel;
function _temp(child, index) {
  return <div key={index} className={css.carouselItem}>{child}</div>;
}